import classNames from 'classnames';
import { times } from 'lodash';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TypeStar } from '../../typings/stars';

import './RatingStars.css';

interface RatingStarsProps {
    readonly: boolean;
    onClick?: (newValue: number) => void;
    value?: number;
    sizeStars?: number;
}

const BLOCK = 'rating-stars';
const COUNT_STARS = 5;
const DEFAULT_SIZE_STAR = 24;

export class RatingStars extends React.PureComponent<RatingStarsProps> {
    render() {
        const { readonly } = this.props;
        return <div className={Bem.cls(BLOCK, '', { edit: !readonly })}>{this.getStars()}</div>;
    }

    private getBorderWidth(starSize: number) {
        return Math.floor(starSize / 10);
    }

    private getStar(order: number, type: TypeStar) {
        const { sizeStars: size = DEFAULT_SIZE_STAR, readonly, value = 0 } = this.props;

        const starTypeMod = {
            [TypeStar.FULL]: 'full',
            [TypeStar.HALF]: 'half',
            [TypeStar.EMPTY]: 'empty'
        }[type];

        return (
            <div
                key={order}
                style={{
                    width: size,
                    height: size,
                    borderRight: `${this.getBorderWidth(size)}px solid transparent`
                }}
                className={classNames(
                    Bem.cls(BLOCK, 'star', {
                        type: starTypeMod,
                        selected: !readonly && value >= order
                    })
                )}
                onClick={() => this.handleClick(order)}
            />
        );
    }

    private handleClick(newValue: number) {
        const { onClick } = this.props;

        if (onClick) {
            onClick(newValue);
        }
    }

    private getStars() {
        const { value = 0 } = this.props;

        return times(COUNT_STARS, index => {
            // звезды отображаются в обратном порядке
            const order = COUNT_STARS - index;

            if (value >= order) {
                return this.getStar(order, TypeStar.FULL);
            }

            if (value >= order - 0.5) {
                return this.getStar(order, TypeStar.HALF);
            }

            return this.getStar(order, TypeStar.EMPTY);
        });
    }
}
